import { SerialSettingsStateType } from './state'

export interface SerialSettingsGettersType {
  getSerialSettingsById: (state: SerialSettingsStateType, id: string) => SerialSettingsStateType['serialSetting']
  getSerialSettingsByPort: (state: SerialSettingsStateType, port: string) => SerialSettingsStateType['serialSetting']
  getSerialSettingsByBaudRate: (state: SerialSettingsStateType, baudRate: number) => SerialSettingsStateType['serialSettings']
}

export const SerialSettingsGetters = {
  getSerialSettingsById: (state: SerialSettingsStateType) => (id: string) => {
    return state.serialSettings.find(serialSetting => serialSetting.id === id)
  },
  getSerialSettingsByPort: (state: SerialSettingsStateType) => (port: string) => {
    return state.serialSettings.find(serialSetting => serialSetting.port === port)
  },
  getSerialSettingsByBaudRate: (state: SerialSettingsStateType) => (baudRate: number) => {
    return state.serialSettings.filter(serialSetting => serialSetting.baudRate === baudRate)
  },
}
